import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  Auth,
  User,
  browserLocalPersistence
} from 'firebase/auth';
import { SignInResponse } from "../storage/types";
import './FirebaseClient'
import { API_URL } from '../constants';

export interface ApiClient {
  // Authentication operations
  signInWithEmail(email: string, password: string): Promise<SignInResponse>
  signInWithGoogle(): Promise<SignInResponse>
  getCurrentUser(): User | null;
}

export class FirebaseApiClient implements ApiClient {
  private baseUrl: string;
  private auth: Auth;

  constructor(baseUrl: string = '/') {
    this.baseUrl = baseUrl;
    this.auth = getAuth();
    this.auth.setPersistence(browserLocalPersistence)
  }

  private async handleSignIn(user: User): Promise<SignInResponse> {
    const token = await user.getIdToken();

    const response = await fetch(`${this.baseUrl}/auth/signin`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Signin failed: ${response.statusText}`);
    }

    return response.json();
  }

  async signInWithEmail(email: string, password: string): Promise<SignInResponse> {
    const result = await signInWithEmailAndPassword(this.auth, email, password);
    return this.handleSignIn(result.user);
  }

  async signInWithGoogle(): Promise<SignInResponse> {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(this.auth, provider);
    return this.handleSignIn(result.user);
  }

  // Update types
  getCurrentUser(): User | null {
    return this.auth.currentUser;
  }

}

// Create and export the client instance
export const firebaseSigninClient = new FirebaseApiClient(API_URL);

